import React, { useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Link } from "react-router-dom";
import Skeleton from '@material-ui/lab/Skeleton';
import { addProductImg } from "../Reducers/authReducer";
import { useDispatch, useSelector } from "react-redux";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import GradeIcon from '@mui/icons-material/Grade';
import formatPrice from './formatPrice';
import ProductCountries from './Header/ProductCountries';
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import FlashOnIcon from '@mui/icons-material/FlashOn';
var moment = require('moment');

function StoreSearchItems({ item, i, isFetching, languageCode, userData, searchCountry }) {
  const dispatch = useDispatch();
  const { t } = useTranslation()
  const isMobcreen = useMediaQuery({ query: '(min-width: 0px) and (max-width: 768px)' })
  function productTitle(title) {
    return title?.replace(/[^A-Za-z0-9]/g, ' ')?.replace(/[^\w\s]/gi, ' ')?.replace(/ /g, '-')
  }

  function addProductImage(data) {
    dispatch(addProductImg({ productImg: data }));
  }

  const handleError = (e) => {
    console.error('Error loading image:', e.target.src);
    e.target.src = 'https://cdn.ebtida.com/1705315901965-Image-not-found.jpg';
  };

  const beforeLoadHandler = () => (
    <img
      className="img-item"
      src='https://cdn.ebtida.com/1705315901965-Image-not-found.jpg' />
  );

  function ratingFucn(rating) {
    if (rating === 0) {
      return false
    } else if (rating === '0') {
      return false
    } else if (!rating) {
      return false
    } else {
      return true
    }
  }

  function getDeliverydays(delivery) {
    const deliveryDaya = Number(delivery) + Number(userData?.contant?.delivery_days || 0)
    function getTimeline() {
      if (Number(deliveryDaya) === 1) {
        return <>{t('delivery_by')} <strong>Tomorrow</strong> {moment().add(Number(deliveryDaya), 'days').format('Do')}</>
      } else {
        return <>{t('delivery_by')} {moment().add(Number(deliveryDaya), 'days').format('Do MMM')}</>
      }
    }
    if (Number(deliveryDaya) > 0) {
      return getTimeline()
    } else {
      return `${t('delivery_by')} ${moment().add(10, 'days').format('Do MMM')}`
    }
  }

  function loadCountrySkeleton(fetch, country, itemCountry) {
    if (!country) {
      return false
    }
    if (fetch && country != itemCountry) {
      return true
    }
    return false
  }

  const storeIds = [1, 3, 18, 19, 20, 21, 22, 23, 25, 11, 12, 26]

  function functionIdLink(id, pid, store_id) {
    if (storeIds?.includes(Number(store_id))) {
      return pid
    } else {
      return id
    }
  }


  return (
    <Link
      className="cardItem-item"
      onClick={(() => addProductImage(item?.image))}
      to={`/${languageCode}/product/${item?.store_id}/${functionIdLink(item?.id, item?.pid, item?.store_id)}/${productTitle(item?.title)}?country=${item?.country}`}>
      <div className="img-card imgCard">
        <LazyLoadImage
          delayTime={100}
          alt={item?.title}
          effect="blur"
          className="img-item"
          src={item?.image}
          onError={handleError}
          beforeLoad={beforeLoadHandler}
        />

        <div className={`delivery-days`}>
          <span style={{ padding: 0 }} className={isMobcreen ? `badge badge-secondary` : ``}>
            {getDeliverydays(item.estimated_delivery)}
          </span>
        </div>
        {item?.prices?.deal_value &&
          <span
            className='badge badge-danger'
            style={{ position: 'absolute', left: '5px', top: '5px', zIndex: 111, width: 'auto' }}>
            <FlashOnIcon style={{ fontSize: '1rem' }} />
          </span>
        }
      </div>
      <div className="card-content">
        <div className='title-card' style={{ maxHeight: '45px', minHeight: '45px' }}>
          <h4>{item?.title?.replace(/[^\w\s.,'/:]/gi, ' ')}</h4>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', lineHeight: 1 }}>
          {item?.brand && <div className='brand' style={{ width: '100%' }}>{item?.brand}</div>}
          {ratingFucn(item?.rating) &&
            <div className='rating' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
              <span style={{ display: 'flex', alignItems: 'center', color: '#575959', margin: '0px 3px', fontSize: '14px' }}>{item?.rating}</span>
              <GradeIcon style={{ color: '#151517', fontSize: '1rem', marginTop: '-1.5px' }} />
            </div>
          }
        </div>
        <div className="content-item" style={{ padding: 0 }}>
          <div className='item-price-card' style={{ alignItems: 'flex-end' }}>
            {Number(item?.prices?.value) === 0 ?
              <span className='badge badge-secondary'>Check Price</span>
              :
              <>
                <span className='item-deal-price'>
                  {formatPrice(item?.prices?.value, item?.prices?.currency, 0)}&nbsp;
                </span>
                {item?.prices?.deal_value &&
                  <span className='item-price' style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <small style={{ textDecoration: 'line-through', color: '#828282' }}>
                      {formatPrice(item?.prices?.price, item?.prices?.currency, 0)}
                    </small>
                    {/* {item?.prices?.discount ?
                        <span className='badge badge-danger'>
                          {`-${item?.prices?.discount}%`}
                        </span> : ``
                      } */}
                  </span>
                }
              </>
            }
          </div>
        </div>

        <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          {loadCountrySkeleton(isFetching, searchCountry, item.country) ?
            <Skeleton style={{ height: '22px', width: '30%' }} /> :
            <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', color: '#575959' }}>
              {t('From')}&nbsp;
              <img
                style={{ width: '20px', objectFit: 'contain' }}
                loading="lazy"
                src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
                srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
                alt=""
              />&nbsp;
              <div style={{ color: '#575959' }}>{ProductCountries(item?.country)}</div>
            </div>
          }
        </div>
      </div>
    </Link>
  );
}

export default StoreSearchItems;